// extracted by mini-css-extract-plugin
export var orderDetails = "_uq-2";
export var orderImage = "_uq-1";
export var orderMeta = "_uq-3";
export var orderSummary = "_uq-0";
export var rightArrow = "_uq-4";